import { createContext, useContext } from "react";
import type { PathHints } from "@/lib/luagate/path-hints";

/** 学習パスの画面に外から渡す章の名前や番号 (lib/luagate/path-hints.ts)。本番は入れないので null のまま */
export const LgPathHintsContext = createContext<PathHints | null>(null);

export function usePathHints(): PathHints | null {
  return useContext(LgPathHintsContext);
}

/**
 * 見るだけの画面 (ログイン無しのデモ /demo) で、済みの記録の代わりに呼ぶ口。null (受講生の画面) なら今までどおり記録する。
 * 項目の頁の「次の項目へ」は記録の前に「済みにしました」の窓を出すので、デモではその窓を出さずにこれを呼び、次の項目へ進む
 */
export const LgPathNoSaveContext = createContext<(() => void) | null>(null);

export function usePathNoSave(): (() => void) | null {
  return useContext(LgPathNoSaveContext);
}
